import { z } from 'zod';

const PublicUserSchema = z.object({
    id: z.number(),
    email: z.string(),
    name: z.string().nullish(),
});

export const ImpersonationStatusSchema = z.object({
    active: z.boolean(),
    realUser: PublicUserSchema.nullable(),
    impersonatingUser: PublicUserSchema.nullable(),
});

export type ImpersonationStatus = z.infer<typeof ImpersonationStatusSchema>;

export const ImpersonationStatusResponseSchema = z.object({
    success: z.boolean(),
    data: ImpersonationStatusSchema,
});
